import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import _ContactUs_ContentWrapper from './_styles/_ContactUs_ContentWrapper'
import { CloseOutlined } from '@ant-design/icons'
import WhatsappIcon from './_icons/WhatsappIcon'
import PhoneIcon from './_icons/PhoneIcon'
import EmailIcon from './_icons/EmailIcon'
import ServiceIcon from './_icons/ServiceIcon'
import ComputerOutIcon from './_icons/ComputerOutIcon'
import SocialTelegramIcon from 'components/IconAntDesign/SocialTelegramIcon'
import SocialSpriteIcon from 'components/IconAntDesign/SocialSpriteIcon'
import { SOCIAL_CONTACTS, SUPPORT_CONTACTS } from 'config'

const SHOW_WHATSAPP_SUPPORT = false

@withTranslation()
export default class ContactUsModalContent extends Component {
  render () {
    const { t } = this.props
    return (
      <_ContactUs_ContentWrapper>
        <header>
          <h2>{t('How can we help you?')}</h2>
          <CloseOutlined
            style={{ cursor: 'pointer', fontSize: '16px' }}
            onClick={this.props.closeModal}
          />
        </header>
        <div className='contact-us-content-body'>
          <section className='support-time-section'>
            <p className='support-title'>{t('Site technical support:')}</p>
            <p>{SUPPORT_CONTACTS.schedule}</p>
          </section>

          {SHOW_WHATSAPP_SUPPORT &&
          <section>
            <div className='with-icon-wrapper'>
              <div className='icon-wrapper'>
                <WhatsappIcon />
              </div>
              <div className='label-wrapper'>
                <a href={SUPPORT_CONTACTS.whatsapp.href} target='_blank' rel='noopener noreferrer'>{SUPPORT_CONTACTS.whatsapp.title}</a>
              </div>
            </div>
          </section>}

          <section>
            <div className='with-icon-wrapper'>
              <div className='icon-wrapper'>
                <SocialTelegramIcon />
              </div>
              <div className='label-wrapper'>
                <a href={SUPPORT_CONTACTS.telegram.href} target='_blank' rel='noopener noreferrer'>{SUPPORT_CONTACTS.telegram.title}</a>
              </div>
            </div>
          </section>

          <section>
            <div className='with-icon-wrapper'>
              <div className='icon-wrapper'>
                <PhoneIcon color='#FF7A24' />
              </div>
              <div className='label-wrapper'>
                <p>{t('Phone:')} <a href={SUPPORT_CONTACTS.phone.href}>{SUPPORT_CONTACTS.phone.title}</a></p>
              </div>
            </div>
          </section>

          <section>
            <div className='with-icon-wrapper'>
              <div className='icon-wrapper'>
                <EmailIcon color='#FF7A24' />
              </div>
              <div className='label-wrapper'>
                <p>{t('Email:')} <a href={SUPPORT_CONTACTS.email.href}>{SUPPORT_CONTACTS.email.title}</a></p>
              </div>
            </div>
            <p>{t('For questions about streams and video:')} <a href={SUPPORT_CONTACTS.mediaEmail.href}>{SUPPORT_CONTACTS.mediaEmail.title}</a></p>
          </section>

          <section>
            <div className='with-icon-wrapper'>
              <div className='icon-wrapper'>
                <ServiceIcon color='#FF7A24' />
              </div>
              <div className='label-wrapper'>
                <p>{t('Order service:')}</p>
                <a href={SUPPORT_CONTACTS.phone.href}>{SUPPORT_CONTACTS.phone.title}</a>
              </div>
            </div>
            <p>{t('Events in rhythmic gymnastics (service details and conditions.)')}</p>
          </section>

          <section>
            <div className='with-icon-wrapper'>
              <div className='icon-wrapper'>
                <ComputerOutIcon color='#FF7A24' />
              </div>
              <div className='label-wrapper'>
                <p>{t('Find out more about our projects:')}</p>
                <a href={SUPPORT_CONTACTS.projects.href} target='_blank' rel='noopener noreferrer'>{SUPPORT_CONTACTS.projects.title}</a>
              </div>
            </div>
          </section>

          <section className='socials-section'>
            <p>{t('Social media:')}</p>
            <div className='socials-links'>
              <a href={SOCIAL_CONTACTS.telegram.href} target='_blank' rel='noopener noreferrer' aria-label={SOCIAL_CONTACTS.telegram.title}>
                <SocialTelegramIcon size={22} color='#9BA6B4' plain />
              </a>
              <a href={SOCIAL_CONTACTS.vk.href} target='_blank' rel='noopener noreferrer' aria-label={SOCIAL_CONTACTS.vk.title}>
                <SocialSpriteIcon type='vk' />
              </a>
              <a href={SOCIAL_CONTACTS.youtube.href} target='_blank' rel='noopener noreferrer' aria-label={SOCIAL_CONTACTS.youtube.title}>
                <SocialSpriteIcon type='youtube' />
              </a>
            </div>
          </section>
        </div>
      </_ContactUs_ContentWrapper>
    )
  }
}
